
import {DownloadDeliveryLogic} from "./download-delivery-logic";
import {
    cleanItem,
    itemEditor,
}                              from "./expo-types/expo-types";

export const basicDownloadDeliveryModules = (
    {
        templateOptions, item,
    }
) => [

    {
        name: "downloadDelivery1",
        load: ({}, next) => DownloadDeliveryLogic({item, templateOptions, next}),
        requires: [],
        expo: [cleanItem],
    },
    {
        name: "downloadDelivery2",
        load: ({downloadDelivery1, method, paperPrice}, next) => ["download"].includes(method) ? (
            downloadDelivery1.next({paperPrice, next})
        ) : (
            next(null)
        ),
        requires: ["downloadDelivery1", "method", "paperPrice"],
        expo: [itemEditor],
    },
];

